module.exports = __webpack_public_path__ + "img/antes_despues_33.43991528.png";